import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  templateData: [],
  updatedData: [],
  calendarExistance: false,
  comprehensiveData: [],
  stepperTask: []
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setTemplateDataRx: (state, action) => {
      state.templateData = action.payload;
      state.updatedData = action.payload;
    },
    updateTemplateDataRx: (state, { payload }) => {
      state.updatedData = payload;
    },
    updateTaskRx: (state, { payload }) => {
      const { taskId, ...rest } = payload;
      state.updatedData = state.updatedData.map((task) =>
        task?.taskId === payload.taskId ? { ...task, ...rest } : task
      );
    },
    setCalendarExistance: (state, action) => {
      state.calendarExistance = action.payload;
    },
    setComprehensiveDataRx: (state, { payload }) => {
      state.comprehensiveData = payload;
    },
    updateComprehensiveTaskRx: (state, { payload }) => {
      const { taskId, ...rest } = payload;
      state.comprehensiveData = state.comprehensiveData.map((task) =>
        task?.taskId === payload.taskId ? { ...task, ...rest } : task
      );
    },
    setStepperTaskRx: (state, { payload }) => {
      state.stepperTask = payload;
    }
  }
});

export const {
  setTemplateDataRx,
  updateTemplateDataRx,
  setCalendarExistance,
  updateTaskRx,
  setComprehensiveDataRx,
  updateComprehensiveTaskRx,
  setStepperTaskRx
} = calendarSlice.actions;

export default calendarSlice.reducer;
